import { apiClient } from './client';

type BackgroundAgentsListParams = Record<string, string | number | boolean | undefined>;

export function getConfigurations (shopId: number | string, params: BackgroundAgentsListParams = {}) {
  return apiClient.get(`/${shopId}/background-agents/configurations`, { params });
}

export function getQueues (shopId: number | string) {
  return apiClient.get(`/${shopId}/background-agents/queues`);
}

export function getRuns (shopId: number | string, params: BackgroundAgentsListParams) {
  return apiClient.get(`/${shopId}/background-agents/runs`, { params });
}

export function getRunSteps (shopId: number | string, runId: string | number, params: BackgroundAgentsListParams = {}) {
  return apiClient.get(`/${shopId}/background-agents/runs/${runId}/steps`, { params });
}

export function getActions (shopId: number | string, params: BackgroundAgentsListParams) {
  return apiClient.get(`/${shopId}/background-agents/actions`, { params });
}

export function getPendingActions (shopId: number | string, params: BackgroundAgentsListParams) {
  return apiClient.get(`/${shopId}/background-agents/actions/pending`, { params });
}
